'use client';
import gtm from 'eco-design-reliance/gtm';

export default function ItemLinkA({
    prefixCls,
    itemA = {},
    itemC1 = {},
    index1 = 0,
    index2 = 0,
}: {
    prefixCls: string;
    itemA: any;
    itemC1: any;
    index1: number;
    index2: number;
}) {
    return (
        <a
            className={`${prefixCls}-sub-href GtmModuleData-btn-href footer-nav-i-${index1}-${index2}`}
            onClick={() => {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'bottom_navigation',
                    list_name: itemA.name,
                    navigation_name: itemC1.heading,

                    __btn_id1: `footer-nav-i-${index1}-${index2}`,
                    __btn_id2: itemC1.url,
                    __btn_type: 'href',
                });
            }}
            href={itemC1.url}
        >
            {itemC1.heading}
        </a>
    );
}
